// src/features/Mailinator/LoadingSkeleton.js
import React from 'react';
import { Box, Skeleton } from '@mui/material';

const LoadingSkeleton = () => {
  return (
    <Box>
      {[...Array(5)].map((_, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <Skeleton variant="rectangular" height={80} />
        </Box>
      ))}
    </Box>
  );
};

export default LoadingSkeleton;
